import { Component, type ReactNode } from 'react';

interface RemoteRouteErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
  onError?: (error: Error) => void;
  resetKey: string;
}

interface RemoteRouteErrorBoundaryState {
  hasError: boolean;
}

export class RemoteRouteErrorBoundary extends Component<
  RemoteRouteErrorBoundaryProps,
  RemoteRouteErrorBoundaryState
> {
  constructor(props: RemoteRouteErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): RemoteRouteErrorBoundaryState {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: RemoteRouteErrorBoundaryProps): void {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error: Error): void {
    this.props.onError?.(error);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
